import { Button, Flex, Input, Table } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getColumns } from './TestCaseColums'
import { AppliedFilter } from './filter/AppliedFilter'

import {
    setFilter,
    setPagination,
    setSearchValue,
    testCaseList,
    testRunState,
} from '../../../../redux/testRun/testRunList.slice'
import AddResultDrawer from './form/AddResultDrawer'
import FilterDrawer from './filter/FilterDrawer'
import { isValidArray } from '../../../../../sprints/components/testReport/testCases/forms/helper'

// small debounce helper (no external deps)
const useDebounce = (value, delay = 400) => {
    const [v, setV] = useState(value)
    useEffect(() => {
        const t = setTimeout(() => setV(value), delay)
        return () => clearTimeout(t)
    }, [value, delay])
    return v
}

//==============================================================================================
const TestCaseList = (props) => {
    const {
        // stateTestRun = {},
        // setStateTestRun = () => {},
        reportId = '',
    } = props

    const dispatch = useDispatch()

    // SELECTORS
    const {
        testCase = [],
        testCaseListLoading = false,
        status = true,
        pagination: { pageSize = 10, currentPage = 0 },
        filter,
        defaultFilter,
        searchValue,
    } = useSelector(testRunState)

    const testCaseListData = testCase?.data || []
    const listLoading = status === 'loading'
    const filterCount =
        (filter?.epic?.length ? 1 : 0) +
        (filter.sprint ? 1 : 0) +
        (filter?.tags?.length ? 1 : 0) +
        (filter?.status ? 1 : 0) +
        (searchValue?.length ? 1 : 0)

    const [stateTestRun, setStateTestRun] = useState({
        drawerEdit: false,
        filterDrawer: false,
        selectedTCID: [],
    })

    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [loading, setLoading] = useState(false)
    const [search, setSearch] = useState('')
    const [testRunModal, setTestRunModal] = useState(false)

    const handleAction = (act, id) => {
        setStateTestRun({
            ...stateTestRun,
            drawerEdit: true,
            editType: act,
            selectedTCID: [id],
        })
    }

    const clearAllFilter = () => {
        dispatch(setFilter(defaultFilter))
        dispatch(setSearchValue(''))
        setSearch('')
    }
    const clearSpecificFilter = (field) => {
        dispatch(
            setFilter({
                ...filter,
                [field]: ['epic', 'tags'].includes(field) ? [] : '',
            })
        )

        if (field === 'search') {
            setSearch('')
            dispatch(setSearchValue(''))
        }
    }

    // Get columns
    const columns = getColumns(handleAction)

    // ✅ Debounce the value
    const debouncedSearch = useDebounce(search, 500)

    // Dispatch search when debounced value changes (and reset to page 1)
    useEffect(() => {
        dispatch(setSearchValue(debouncedSearch?.trim() || ''))
        dispatch(setPagination({ pageSize, currentPage: 1 }))
    }, [debouncedSearch, dispatch, pageSize])
    // // Handle search change

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    }
    const hasSelected = selectedRowKeys.length > 0

    // AntD pagination config (controlled)
    const pagination = {
        current: currentPage,
        pageSize,
        total: testCase?.count || 100,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20', '50'],
        showTotal: (t, range) => `${range[0]}-${range[1]} of ${t}`,
        onChange: (page, size) => {
            // If user also changed size, AntD resets page to 1 by default—do it explicitly:
            if (size !== pageSize) {
                dispatch(
                    setPagination({
                        pageSize: size,
                        currentPage: 1,
                    })
                )
            } else {
                dispatch(
                    setPagination({
                        pageSize: size,
                        currentPage: page,
                    })
                )
            }
        },
    }

    const tagsArray = filter?.tags?.map((item) => item?.value) || []
    const epic = isValidArray(filter?.epic)
        ? filter?.epic?.map((item) => item?.value)
        : []
    const sprint = filter?.sprint?.value || ''
    const filterStatus = filter?.status?.value
        ? filter?.status?.value
        : filter?.status

    const handleTestCaseList = useCallback(
        (search = '') => {
            const payload = {
                skip: (currentPage - 1) * pageSize,
                limit: pageSize,
                filter: {
                    epic: epic || [],
                    sprint: sprint || '',
                    ...(isValidArray(filter?.tags)
                        ? {
                              tags: tagsArray,
                          }
                        : {}),
                    status: filterStatus,
                },
                search: {
                    title: searchValue,
                    testId: searchValue,
                },
                sort: 'createdAt',
                sortType: 'desc',
                reportId: reportId,
            }
            dispatch(testCaseList(payload))
        },
        [dispatch, currentPage, pageSize, searchValue, filter]
    )

    useEffect(() => {
        handleTestCaseList()
    }, [handleTestCaseList])
    console.log('Log ==>filterCount', filterCount)
    return (
        <Flex gap="middle" vertical>
            <Flex align="center" gap="10px" justify="space-between">
                <div
                    className=""
                    style={{
                        left: 0,
                        padding: '0px',
                    }}
                >
                    {hasSelected
                        ? `Selected ${selectedRowKeys.length} items`
                        : null}
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'center',
                        gap: 10,
                        width: '70%',
                    }}
                >
                    <Button
                        type="default"
                        onClick={() => {
                            setStateTestRun({
                                ...stateTestRun,
                                filterDrawer: true,
                            })
                        }}
                        // disabled={!hasSelected}
                        loading={loading}
                        size="small"
                    >
                        Filter
                    </Button>
                    <Button
                        type="default"
                        onClick={() => {
                            setStateTestRun({
                                selectedTCID: selectedRowKeys,
                                drawerEdit: true,
                                editType: 'bulk',
                            })
                        }}
                        disabled={!hasSelected}
                        loading={loading}
                        size="small"
                    >
                        Bulk Edit
                    </Button>
                    <Input
                        size="large"
                        placeholder="Search test cases (title, id)"
                        allowClear
                        // enterButton
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{
                            maxWidth: 360,
                            lineHeight: 1.8,
                            borderRadius: '4px',
                        }}
                    />
                </div>
            </Flex>
            {!!filterCount && (
                <Flex align="center" gap="middle" justify="start">
                    <AppliedFilter
                        data={filter}
                        searchValue={searchValue}
                        onClearAll={clearAllFilter}
                        onRemove={clearSpecificFilter}
                    />
                </Flex>
            )}
            <div
                style={{
                    width: '100%',
                    marginTop: '10px',
                    position: 'relative',
                }}
            >
                {/* <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'end',
                        marginBottom: 10,
                    }}
                >
                    <Input
                        size="large"
                        placeholder="Search test cases (title, description...)"
                        allowClear
                        // enterButton
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ maxWidth: 360 }}
                    />
                </div> */}
                <Table
                    style={{ width: '100%', overflow: 'auto' }}
                    // tableLayout="fixed"
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={testCaseListData}
                    rowKey={'_id'}
                    loading={testCaseListLoading}
                    pagination={pagination}
                />
                {/* <div
                    className=""
                    style={{
                        position: 'absolute',
                        bottom: 20,
                        left: 0,
                        padding: '0px',
                        // background: '#fff',
                        width: '100%',
                        // borderTop: '1px solid #f0f0f0',
                    }}
                >
                    {hasSelected
                        ? `Selected ${selectedRowKeys.length} items`
                        : null}
                </div> */}
            </div>
            {/* <CreateTestRunModal
                isOpen={testRunModal}
                setOpen={setTestRunModal}
                selectedRowKeys={selectedRowKeys}
            /> */}

            <AddResultDrawer
                stateTestRun={stateTestRun}
                setStateTestRun={setStateTestRun}
                selectedRowKeys={selectedRowKeys}
                setSelectedRowKeys={setSelectedRowKeys}
                reportId={reportId}
                handleTestCaseList={handleTestCaseList}
            />
            <FilterDrawer
                stateTestRun={stateTestRun}
                setStateTestRun={setStateTestRun}
            />
        </Flex>
    )
}
export default TestCaseList
